/**
 * The values offered in the purchase form's drop-downs (owner request, 2026-10-08: the vintage and
 * the quantity are picked rather than typed).
 */
import type { MonthValue } from './months';

/** The oldest vintage listed; an older one already saved stays listed for its wine. */
export const FIRST_LISTED_VINTAGE = 1900;
/** The most bottles listed for one purchase; a larger one already saved stays listed. */
export const MAX_LISTED_QUANTITY = 120;

/** Next year down to 1900, newest first (a vintage is plausible up to next year), plus `current`. */
export function vintageChoices(now: MonthValue, current?: number): number[] {
  const years: number[] = [];
  for (let year = now.year + 1; year >= FIRST_LISTED_VINTAGE; year--) years.push(year);
  if (current !== undefined && Number.isInteger(current) && !years.includes(current)) {
    years.push(current);
    years.sort((a, b) => b - a);
  }
  return years;
}

/** 1 to 120 bottles, plus `current` when a purchase already has more. */
export function quantityChoices(current?: number): number[] {
  const quantities = Array.from({ length: MAX_LISTED_QUANTITY }, (_, i) => i + 1);
  if (current !== undefined && Number.isInteger(current) && current > MAX_LISTED_QUANTITY) {
    quantities.push(current);
  }
  return quantities;
}
